import React from 'react';
import VideoAppointmentConfirmation from 'resources/appointment_dates/VideoAppointmentConfirmation';

const AppointmentDates = props => {
  return <VideoAppointmentConfirmation {...props} />;
};

export default AppointmentDates;
